import React from 'react';
import { useAuth } from '../auth/AuthContext.js';

export function SettingsPage(): JSX.Element {
  const { payload } = useAuth();
  return (
    <section>
      <h1 style={{ marginTop: 0 }}>Account</h1>
      <dl>
        <dt>Email</dt>
        <dd>{payload?.user.email ?? '(loading)'}</dd>
        {payload?.user.displayName ? (
          <>
            <dt>Name</dt>
            <dd>{payload.user.displayName}</dd>
          </>
        ) : null}
      </dl>
      <details>
        <summary>Info</summary>
        <ul>
          {(payload?.privileges ?? []).map((p) => (
            <li key={p}>
              <code>{p}</code>
            </li>
          ))}
        </ul>
      </details>
    </section>
  );
}
